import React, { useState } from 'react';
import { Button } from './Button';
import { Link } from 'react-router-dom';
import './Navbar.css';
import Logo from '../assets/logo.png'; // your logo

function Navbar() {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  return (
    <>
      <nav className='navbar'>
        <Link to='/' className='navbar-logo' onClick={closeMobileMenu}>
          <img src={Logo} alt='Life Long Learners' className='logo-img' />
          Life Long Learners
        </Link>

        <div className='menu-icon' onClick={handleClick}>
          <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
        </div>

        <ul className={click ? 'nav-menu active' : 'nav-menu'}>
          <li className='nav-item'>
            <Link to='/' className='nav-links' onClick={closeMobileMenu}>Home</Link>
          </li>
          <li className='nav-item'>
            <Link to='/our-journey' className='nav-links' onClick={closeMobileMenu}>Our Journey</Link>
          </li>
          <li className='nav-item'>
            <Link to='/our-team' className='nav-links' onClick={closeMobileMenu}>Our Team</Link>
          </li>
          <li className='nav-item'>
            <Link to='/resources' className='nav-links' onClick={closeMobileMenu}>Resources</Link>
          </li>
          <li className='nav-item'>
            <Link to='/contact-us' className='nav-links' onClick={closeMobileMenu}>Contact Us</Link>
          </li>
          <li className='nav-item'>
            <Link to='/apply' className='nav-links-mobile' onClick={closeMobileMenu}>Apply</Link>
          </li>
        </ul>

        {/* Apply Button Wrapper */}
        <div className="navbar-button-wrapper">
          <Button />
        </div>
      </nav>
    </>
  );
}

export default Navbar;
